import React, { useEffect, useRef } from 'react';
import './style.css';
import {ReactComponent as Banner1} from '../../assets/images/banner-bg-1.svg';
import {ReactComponent as Banner2} from '../../assets/images/banner-bg-2.svg';
import {ReactComponent as MBanner1} from '../../assets/images/mbg-banner1.svg';
import {ReactComponent as MBanner2} from '../../assets/images/mbg-banner2.svg';
import {ReactComponent as BannerShoe1} from '../../assets/images/banner-shoe-1.svg';
import {ReactComponent as BannerShoe2} from '../../assets/images/banner-shoe-2.svg';
import {ReactComponent as Mic} from '../../assets/images/mic.svg';
import {ReactComponent as Laptop} from '../../assets/images/Laptop.svg';
import {ReactComponent as Boy} from '../../assets/images/boy.svg';
import {ReactComponent as Girl} from '../../assets/images/redesign-girl-default.svg';
import {ReactComponent as Chair} from '../../assets/images/chair.svg';
import {gsap, ScrollTrigger, MotionPathPlugin, MotionPathHelper } from 'gsap/all';
import { ReactComponent as Figma } from '../../assets/images/figma.svg';
import { ReactComponent as Sketch } from '../../assets/images/sketch.svg';
gsap.registerPlugin(ScrollTrigger);

export default function Banner() {

 let height = window.innerHeight + 'px';
 let width = window.innerWidth + 'px';

 let wrapperRef = useRef(null);
 let girlRef = useRef(null);
 let boyRef = useRef(null);
 let chairRef = useRef(null);
 let laptopRef = useRef(null);
 let micRef = useRef(null);
 let shoe1Ref = useRef(null);
 let shoe2Ref = useRef(null);
 let textRef = useRef(null);

  useEffect(() => {
    if(window.innerWidth >= 769){
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: wrapperRef.current,
        scrub: true,
        start: "+450px 62%",
        end: "+450px 10% ",
        // markers:true
      }
    });

    tl.to([micRef.current], {
      x: -50,
      y: -100,
      transform: `rotate(-110deg)`,
      duration: 2,
    });

    gsap.to(textRef.current, {
      scrollTrigger: {
        trigger: wrapperRef.current,
        scrub: true,
        start: "+450px 62%",
        end: "+450px 10% ",
        // markers:true
      },
      y: -200,
      duration: 7
    })

    gsap.to(laptopRef.current, {
      scrollTrigger: {
        trigger: wrapperRef.current,
        scrub: true,
        start: "+450px 62%",
        end: "+450px 10% ",
        // markers:true
      },
      y: -400,
      x: 100,
      transform: 'rotate(90deg)',
      duration: 7
    });

    gsap.to(shoe1Ref.current, {
      scrollTrigger: {
        trigger: wrapperRef.current,
        scrub: true,
        // pin: true,
        start: "+450px 62%",
        end: "+450px 10% ",
        // markers:true
      },
      y: -300
    });

    gsap.to(shoe2Ref.current, {
      scrollTrigger: {
        trigger: wrapperRef.current,
        scrub: true,
        // pin: true,
        start: "+450px 62%",
        end: "+450px 10% ",
        // markers:true
      },
      y: -200
    });

    gsap.to(chairRef.current, {
      scrollTrigger: {
        trigger: wrapperRef.current,
        scrub: true,
        // pin: true,
        start: "+450px 62%",
        end: "+450px 10% ",
        // markers:true
      },
      y: -200,
      x: 100,
      transform: 'rotate(30deg)'
    });

    gsap.to(boyRef.current, {
      scrollTrigger: {
        trigger: wrapperRef.current,
        scrub: true,
        // pin: true,
        start: "+450px 62%",
        end: "+450px 10% ",
        // markers:true
      },
      y: -350,
      transform: 'rotate(-15deg)'
    });

    // let tl = gsap.to(girlRef.current, {
    //   motionPath: {
    //     path: 'M9,100c0,0,18.53-41.58,49.91-65.11c30-22.5,65.81-24.88,77.39-24.88c33.87,0,57.55,11.71,77.05,28.47c23.09,19.85,40.33,46.79,61.71,69.77c24.09,25.89,53.44,46.75,102.37,46.75c22.23,0,40.62-2.83,55.84-7.43c27.97-8.45,44.21-22.88,54.78-36.7c14.35-18.75,16.43-36.37,16.43-36.37',
    //   },
    //   // scrollTrigger: {
    //   //   // scrub: true,
    //   // },
    //   // transform: `translate3d(70vw, 1700px , 0) rotate(0deg)`,
    //   ease: "none",
    // });
  }
  }, [])

  return (
    <div ref={wrapperRef} className='banner-wrapper w-full'>
      <Banner2 className='curve-bg-2'/>
      <Banner1 className='curve-bg-1'/>
      {/* <MBanner2 className=' sm:hidden curve-bg-2'/>
      <MBanner1 className=' sm:hidden curve-bg-1'/>  */}
      <div ref={textRef} className='hidden banner-text flex-wrap secondary-text sm:block'>
          <h1 className='text-white text-6xl sm:text-6xl leading-tight font-extrabold w-full text-center main-font'>
            Hey! I'm a
          </h1>
          <h1 className='text-white text-6xl sm:text-6xl leading-tight font-extrabold w-full text-center main-font'> 
            customizable library
          </h1>
          <h1 className='text-white text-6xl sm:text-6xl leading-tight font-extrabold w-full text-center main-font'>
            of illustrations
          </h1>
          <p className='text-white lg:text-2xl sm:text-lg w-3/4 mx-auto text-center pt-8 secondary-font options-para'>
            Reimagine, recreate and redesign the illustrations for commercial and personal use
          </p>
        <div className='w-full text-center mt-20 sm:h-12 interact-icon'>
          <a href="https://gum.co/kyoKZ"  className='interact-icon download-btn py-3 px-3 font-extrabold rounded inline-block w-full sm:w-48 h-14 mt-2 main-font' download> 
            DOWNLOAD
          </a> 
          <div className='nav-cta-wrapper justify-center	mt-4 sm:hidden'>
            <div className='flex justify-center items-center bg-white w-10 h-10 rounded-full ml-4' >
              <a href="https://gum.co/kyoKZ" aria-label="Figma Icon"><Figma /></a>
            </div>
            <div className='flex justify-center items-center bg-white w-10 h-10 rounded-full ml-4' >
              <a href="https://gum.co/kyoKZ" aria-label="Sketch Icon"><Sketch /></a>
            </div>
          </div>
        </div>
      </div>
      <div ref={textRef} className='block banner-text flex-wrap secondary-text sm:hidden'>
          <h1 className='text-white text-6xl sm:text-6xl leading-tight font-extrabold w-full text-center main-font'>
            Hey! I'm a
          </h1>
          <h1 className='text-white text-6xl sm:text-6xl leading-tight font-extrabold w-full text-center main-font'> 
            customizable 
          </h1>
          <h1 className='text-white text-6xl sm:text-6xl leading-tight font-extrabold w-full text-center main-font'>
            library of 
          </h1>
          <h1 className='text-white text-6xl sm:text-6xl leading-tight font-extrabold w-full text-center main-font'>
            illustrations
          </h1>
          <p className='text-white lg:text-2xl sm:text-lg w-3/4 mx-auto text-center pt-8 secondary-font options-para'>
            Reimagine, recreate and redesign the illustrations for commercial and personal use
          </p>  
        <div className='w-full text-center mt-20 sm:h-12 interact-icon'>
          <a href="https://gum.co/kyoKZ"  className='interact-icon download-btn py-3 px-3 font-extrabold rounded inline-block w-full sm:w-48 h-14 mt-2 main-font'> 
            DOWNLOAD 
          </a> 
          <div className='nav-cta-wrapper justify-center	mt-4 sm:hidden'>
            <div className='flex justify-center items-center bg-white w-10 h-10 rounded-full ml-4' >
              <a href="https://gum.co/kyoKZ" aria-label="Figma Icon"><Figma /></a>
            </div>
            <div className='flex justify-center items-center bg-white w-10 h-10 rounded-full ml-4'>
              <a href="https://gum.co/kyoKZ"  aria-label="Sketch Icon"><Sketch /> </a>
            </div>
          </div>
        </div>
      </div>
      <div className='float-elements absolute top-0 left-0 sm:pb-32' style={{height: height, width: width}}>
        <div className=' relative' style={{width, height}}>
        <Mic ref={micRef} className='float-element mic'/>
         <Laptop ref={laptopRef} className='float-element laptop' />

        {/* <Girl ref={girlRef} className='float-element girl opacity-25' /> */}
        
        <Boy 
          ref={boyRef}
          className='hidden sm:block float-element boy' 
          style={(window.innerWidth < 769 ) ? {display: 'none'} : {}}
        />
        <Chair 
          ref={chairRef} 
          className='hidden sm:block float-element chair'
          style={(window.innerWidth < 769 ) ? {display: 'none'} : {}}
        />

        <BannerShoe1 ref={shoe1Ref} className='float-element shoe1'/>
        <BannerShoe2 ref={shoe2Ref} className='hidden sm:block float-element shoe2'/> 
        </div>
      </div>
    </div>
  )
}
